import {uiPartCreateNamespacedParts} from "@wix/devzai-utils-common";

export const DoppeViewerModalsControllerParts = uiPartCreateNamespacedParts('DoppeViewerModalsControllerParts', {
    Overlay: 'Overlay'
})